module.exports = __webpack_public_path__ + "assets/img/c-i3.7d52a65c.png";